import { Form } from "react-bootstrap"
import SelectedGovPanel from "../../api/Randoms/GovPoolModel/GovPerformCollection"
import { PanelResult } from "../../api/GovPerformCollection/PanelResult"

export interface MainPanelRowProps {
  panel: SelectedGovPanel
  onUpdatePanel: (panel: SelectedGovPanel) => void
}

const MainPanelRow = (props: MainPanelRowProps) => {
  const { panel, onUpdatePanel } = props

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value)
    const newPanel = { ...panel, SelectedStatus: value }
    if ([PanelResult.POSITIVE, PanelResult.INCONCLUSIVE].includes(value)) {
      newPanel.SendToLab = 1
    }
    onUpdatePanel(newPanel)
  }

  const onToggleSendToLab = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpdatePanel({ ...panel, SendToLab: e.target.checked ? 1 : 0 })
  }


  if (panel.ExternalID === "") {
    return (
      <tr className="text-muted">
        <td>
          {panel.Label}
        </td>
        <td colSpan={4} className="text-center">Not Available</td>
      </tr>
    )
  }

  return (
    <tr>
      <td>
        {panel.Label}
      </td>
      <td>
        <Form.Check inline name={`panel_${panel.InternalCode}`} type="radio"
          value={PanelResult.POSITIVE}
          checked={panel.SelectedStatus === PanelResult.POSITIVE}
          onChange={onChange} />
      </td>
      <td>
        <Form.Check inline name={`panel_${panel.InternalCode}`} type="radio"
          value={PanelResult.INCONCLUSIVE}
          checked={panel.SelectedStatus === PanelResult.INCONCLUSIVE}
          onChange={onChange} />
      </td>
      <td>
        <Form.Check inline name={`panel_${panel.InternalCode}`} type="radio"
          value={PanelResult.NEGATIVE}
          checked={panel.SelectedStatus === PanelResult.NEGATIVE}
          onChange={onChange} />
      </td>
      <td>
        <Form.Check inline type="checkbox"
          value={panel.SendToLab}
          disabled={panel.SelectedStatus === PanelResult.NOT_SELECTED}
          checked={panel.SendToLab === 1}
          onChange={onToggleSendToLab} />
      </td>
    </tr>
  )
}

export default MainPanelRow
